import Clarity from '@microsoft/clarity';

function readCookie(name) {
    return document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1] ?? null;
}

function identifyCurrentUser() {
    const u = window.__clarityUser;
    if (!u || !u.id) return;

    Clarity.identify(u.id, undefined, undefined, u.name);

    if (u.name) Clarity.setTag('userName', u.name);
    if (u.email) Clarity.setTag('email', u.email);
}

const projectId = window.__clarityProjectId;

if (projectId && readCookie('CookieConsentDismissed') === 'true') {
    Clarity.init(projectId);
    identifyCurrentUser();
}

window.Clarity = Clarity;